import { useDispatch } from 'react-redux'

import { emptyReleaseNote } from '@cbgms/api/modules/releasenotes/mocks'
import { generateSubmissionError } from 'utils-support/Form/SubmissionError'
import { createReleaseNote } from 'app-support/releasenotes/state/actions'
import { CountryCode } from '@carsys/enums/country-code'
import { IReleaseNote } from '@cbgms/api/modules/releasenotes'
import ReleaseNotesForm from './Form'
import { useTranslation } from 'react-i18next'
import { useNotifier } from '@cbgms/base/notifier'

const NewReleaseNotesForm = () => {
  const dispatch = useDispatch()
  const { t } = useTranslation()
  const notifier = useNotifier()

  const onSubmit = async (values: IReleaseNote) => {
    try {
      const { Data } = await dispatch(createReleaseNote(values))

      return `/release-notes/edit/${Data.UUID}`
    } catch (error) {
      throw generateSubmissionError(error)
    }
  }
  const initialValues = emptyReleaseNote({
    URLs: [
      {
        Country: CountryCode.NL,
        URL: ''
      },
      {
        Country: CountryCode.GB,
        URL: ''
      }
    ]
  })

  const onSubmitSuccess = async () => {
    notifier.success(t('releasenotes.created_successfully'))
  }

  return (
    <ReleaseNotesForm
      form='releasenotes_new'
      redirectToURL='/release-notes'
      onSubmit={(values: IReleaseNote) => onSubmit(values)}
      onSubmitSuccess={onSubmitSuccess}
      initialValues={initialValues}
    />
  )
}

export default NewReleaseNotesForm
